import Input from 'components/core/Input'

export default function AuthToken({ fieldName }) {
  return <Input fieldName={fieldName} label="Auth Token" />
}
